(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const updateVideo = () => {
    document.querySelectorAll('[data-jpc-hero-video]').forEach((video) => {
      if (reducedMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    });
  };
  updateVideo();
  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', updateVideo);
  }
})();
